module.exports = __webpack_public_path__ + "img/clean-code.85d31d8a.jpg";